import { useState } from "react";
import { useEffect } from "react";
import swal from 'sweetalert2';
import * as helper from '../global/helper';
import { getAppServiceByType, postAppService } from "../api/golfClubAPI";

const AndroidService = (props) =>{

    const [android,                  setAndroid]                  = useState({});

    useEffect(() => {
        props.title("Android Service", "android-service")
        fetchAppService();
    }, []);
    
    const fetchAppService = async() =>{
        try {
            const service = await getAppServiceByType('Android')  
            setAndroid(service);             
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })  
        }
    }
        
    const updateAndroidDetails = (field, value) => {   
        setAndroid((d) => {
            return { ...d, [field]: value };
        });
    };

    const updateAndroidHandler = async() => {

        const btn = $('#btnUpdate');
        var form = $('#add-android-form');
        
        form.validate({
            rules: {
                txtMessage: {
                    required: true
                }       
            },
            messages: {
                txtMessage: {
                    required: "Please enter message"
                }
            }
        });

        if (!form.valid()) return;
        helper.StartProcessing(btn);

        try {
            await postAppService(android);
            helper.StopProcessing(btn);
            fetchAppService();
            swal.fire({
                icon: 'success',
                titleText: 'Android Service updated!',
                showConfirmButton: false,
                timer: 1500,
            });

        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonclassName    : 'btn btn-brand',
            });
            return;
        }
    }


    return(
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content" >
                <div className="kt-container  kt-container--fluid kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet kt-portlet--mobile">
                        <div className="kt-portlet__body padding-t30 padding-b0">
                            <form className="kt-form" id="add-android-form">
                                <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                    <div className="form-group row">
                                    <label className="col-form-label col-lg-3">Message</label>
                                        <div className="col-xl-6 col-lg-8">
                                            <textarea 
                                                id="txtMessage" 
                                                name="txtMessage" 
                                                className="form-control" 
                                                rows="3"
                                                value={android.Message || ''}
                                                onChange={(event) => updateAndroidDetails('Message', event.target.value)}
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Is Running</label>
                                        <div className="col-xl-6 col-lg-8">
                                            <span className="kt-switch kt-switch--icon">
                                                <label>
                                                    <input 
                                                        id="chkIsRunning" 
                                                        name="chkIsRunning" 
                                                        type="checkbox" 
                                                        checked={android.IsRunning == 'Y' ? 'checked' : ''}
                                                        onChange={(event) => updateAndroidDetails('IsRunning', event.target.checked ? 'Y' : 'N')} 
                                                    />
                                                    <span></span>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div> 
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <div className="row">
                                    <div className="col-lg-9 ml-lg-auto">
                                        <button id="btnUpdate" type="button" className="btn btn-brand d-inline-block" onClick={updateAndroidHandler}>Update</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AndroidService;